import { render, staticRenderFns } from "./EmployerCustomization.vue?vue&type=template&id=944c16d2"
import script from "./EmployerCustomization.vue?vue&type=script&lang=ts"
export * from "./EmployerCustomization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports